
import { getPath } from '@/router/common'

const baseUrl = {
  title: '通讯中心',
  path: 'PushManage'
}
export default [
  {
    path: getPath('Index', baseUrl),
    name: 'PushManage',
    component: () => import(/* webpackChunkName: "PushManage" */ '@/views/pushManage/pushManage/index.vue'),
    meta: {
      title: '推送管理'
    }
  }
]
